// extracted by mini-css-extract-plugin
export default {"button":"LoadingButton_button__jCyHB","dot":"LoadingButton_dot__hF9xy","dot-pulse":"LoadingButton_dot-pulse__fx21t","deleting":"LoadingButton_deleting__5KuLn"};